module.exports = __webpack_public_path__ + "static/img/Andrew-Brayshaw.5f2b524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Brayshaw.jpg
// module id = 97dT
// module chunks = 0